const initialState = {
  fetching: false,
};

export default function videoExerciseReducer(currentState = initialState, action) {
  switch (action.type) {
    case 'VIDEO_EXERCISE_FETCHING':
      return { ...currentState, fetching: true };
    case 'VIDEO_EXERCISE_FETCHED':
      return { ...currentState, data: action.payload.data, fetching: false };
    case 'VIDEO_TYPE_EXERCISE_FETCHING':
      return { ...currentState, fetching: true };
    case 'VIDEO_TYPE_EXERCISE_FETCHED':
      return { ...currentState, videoTypes: action.payload.data, fetching: false };
    case 'VIDEO_URL_TYPE_EXERCISE_FETCHING':
      return { ...currentState, fetching: true };
    case 'VIDEO_URL_TYPE_EXERCISE_FETCHED':
      return { ...currentState, videoUrlTypes: action.payload.data, fetching: false };
    case 'VIDEO_EXERCISE_ADDING':
      return { ...currentState, loading: true };
    case 'VIDEO_EXERCISE_ADDED':
      return { ...currentState, loading: false };
    case 'VIDEO_EXERCISE_DELETING':
      return { ...currentState, loading: true };
    case 'VIDEO_EXERCISE_DELETED':
      return { ...currentState, loading: false };
    default:
      return currentState;
  }
}
